import { useState } from 'react';
import NotificationDrawer from '../../pages/notifications/components/NotificationDrawer';
import HelpDeskDrawer from '../../pages/help-desk/components/HelpDeskDrawer';
import LanguageDropdown from '../language/LanguageDropdown';
import { useLanguage } from '../../contexts/LanguageContext';

export default function NotificationIcons() {
  const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] = useState(false);
  const [isHelpDeskDrawerOpen, setIsHelpDeskDrawerOpen] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  // Try to use language context for testing
  let t;
  try {
    const { t: translate } = useLanguage();
    t = translate;
  } catch (error) {
    t = (key: string) => key; // Fallback
  }

  const openNotificationDrawer = () => setIsNotificationDrawerOpen(true);
  const closeNotificationDrawer = () => setIsNotificationDrawerOpen(false);

  const openHelpDeskDrawer = () => setIsHelpDeskDrawerOpen(true);
  const closeHelpDeskDrawer = () => setIsHelpDeskDrawerOpen(false);

  const toggleLanguageDropdown = () => setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  const closeLanguageDropdown = () => setIsLanguageDropdownOpen(false);

  return (
    <>
      <div className="flex gap-5">
        <div className="relative">
          <div 
            className="w-11 h-11 bg-white rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={toggleLanguageDropdown}
            title={t('common.notifications')}
          >
            <img src="/img/globe.svg" className="w-[19px] h-[19px]" alt="Language" />
          </div>
          <LanguageDropdown 
            isOpen={isLanguageDropdownOpen} 
            onClose={closeLanguageDropdown} 
          />
        </div>
        <div 
          className="w-11 h-11 bg-white rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={openNotificationDrawer}
          title={t('common.notifications')}
        >
          <img src="/img/Union.svg" className="w-[19px] h-[20px]" alt="Notifications" />
        </div>
        <div 
          className="w-11 h-11 bg-white rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={openHelpDeskDrawer}
          title={t('common.helpDesk')}
        >
          <img src="/img/message-notify.svg" className="w-[19px] h-[19px]" alt="Help Desk" />
        </div>
      </div>

      {/* Notification Drawer */}
      <NotificationDrawer 
        isOpen={isNotificationDrawerOpen} 
        onClose={closeNotificationDrawer} 
      />

      {/* Help Desk Drawer */}
      <HelpDeskDrawer 
        isOpen={isHelpDeskDrawerOpen} 
        onClose={closeHelpDeskDrawer} 
      />
    </>
  );
}
